<div class="page-heading">
  <h4 class="page-title text-left">
    <i class="fab fa-whatsapp fa-lg" style="color: #25D366;"></i> Configurar Integração com Whatsapp
  </h4>
  <p class="page-subtitle">
    Configure sua conexão e defina a estratégia de envio fora da janela de 24h.
  </p>
</div>

<!-- Card de informações do Trial
<div class="trial-info-card" *ngIf="trialInfo">
  <div class="trial-status">
    <div class="status-indicator" [ngClass]="{'active': trialInfo.ativo, 'expired': !trialInfo.ativo}">
      <i class="fas" [ngClass]="{'fa-clock': trialInfo.ativo, 'fa-exclamation-circle': !trialInfo.ativo}"></i>
    </div>
    <div class="status-text">
      <h6>{{ trialInfo.ativo ? 'Trial Ativo' : 'Trial Expirado' }}</h6>
      <span class="days-left" *ngIf="trialInfo.ativo">{{ trialInfo.diasRestantes }} dias restantes</span>
      <span class="expired-text" *ngIf="!trialInfo.ativo">Ative o serviço para continuar</span>
    </div>
  </div>
  <div class="trial-progress" *ngIf="trialInfo.ativo">
    <div class="progress-bar">
      <div class="progress-fill" [style.width]="trialInfo.percentualRestante + '%'"></div>
    </div>
    <div class="trial-dates">
      <span>Início: {{ trialInfo.dataInicio | date:'dd/MM/yyyy' }}</span>
      <span>Término: {{ trialInfo.dataFim | date:'dd/MM/yyyy' }}</span>
    </div>
  </div>
</div>
-->

<!-- Notificação de Trial Ativado -->
<div *ngIf="trialAtivadoRecentemente" class="trial-success-notification">
  <div class="trial-notification-content">
    <div class="notification-icon">
      <i class="fas fa-check-circle pulse-animation"></i>
    </div>
    <div class="notification-text">
      <h5>Trial Ativado com Sucesso!</h5>
      <p>Parabéns! Seu período de teste gratuito de 30 dias foi iniciado. Aproveite todos os recursos premium do WhatsApp Business API sem custos de plataforma. <strong>Atenção:</strong> Custos da plataforma META podem ser aplicáveis de acordo com o volume de conversas e mensagens enviadas.</p>
      <p class="trial-dates">
        <span><strong>Início:</strong> {{dataInicioTrial | date:'dd/MM/yyyy'}}</span>
        <span><strong>Término:</strong> {{dataFimTrial | date:'dd/MM/yyyy'}}</span>
        <span><strong>Dias restantes:</strong> {{diasRestantesTrial}}</span>
      </p>
    </div>
    <button class="btn-close" (click)="fecharNotificacaoTrial()">
      <i class="fas fa-times"></i>
    </button>
  </div>
</div>

<div class="whatsapp-signup-container">
  <div id="fb-root"></div>

  <ng-container *ngIf="!dadosIntegracao.associado">
    <div class="signup-modern">
      <!-- Hero Section -->
      <div class="hero-section">
        <div class="hero-icon">
          <div class="icon-circle">
            <i class="fab fa-whatsapp"></i>
          </div>
          <div class="icon-ring"></div>
        </div>
        <h2 class="hero-title">Conecte seu WhatsApp Business</h2>
        <p class="hero-subtitle">
          Transforme a comunicação com seus clientes usando a API oficial do WhatsApp Business
        </p>
      </div>

      <!-- Benefits Grid -->
      <div class="benefits-grid">
        <div class="benefit-card">
          <div class="benefit-icon benefit-icon-blue">
            <i class="fas fa-comments"></i>
          </div>
          <div class="benefit-content">
            <h4>Comunicação Direta</h4>
            <p>Envie mensagens personalizadas diretamente para seus clientes</p>
          </div>
        </div>

        <div class="benefit-card">
          <div class="benefit-icon benefit-icon-green">
            <i class="fas fa-bell"></i>
          </div>
          <div class="benefit-content">
            <h4>Notificações Automáticas</h4>
            <p>Mantenha seus clientes atualizados sobre pedidos em tempo real</p>
          </div>
        </div>

        <div class="benefit-card">
          <div class="benefit-icon benefit-icon-purple">
            <i class="fas fa-headset"></i>
          </div>
          <div class="benefit-content">
            <h4>Atendimento Eficiente</h4>
            <p>Melhore o suporte ao cliente com respostas rápidas e precisas</p>
          </div>
        </div>
      </div>

      <!-- Steps Section -->
      <div class="steps-section">
        <h5 class="steps-title">Como conectar em 3 passos simples</h5>
        <div class="steps-timeline">
          <div class="step-item">
            <div class="step-number">1</div>
            <div class="step-content">
              <h6>Login Facebook</h6>
              <p>Faça login com sua conta do Facebook</p>
            </div>
          </div>
          <div class="step-connector"></div>
          <div class="step-item">
            <div class="step-number">2</div>
            <div class="step-content">
              <h6>Selecione a Conta</h6>
              <p>Escolha sua conta WhatsApp Business</p>
            </div>
          </div>
          <div class="step-connector"></div>
          <div class="step-item">
            <div class="step-number">3</div>
            <div class="step-content">
              <h6>Autorize</h6>
              <p>Autorize o acesso ao WhatsApp</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Info Banner -->
      <div class="info-banner">
        <i class="fas fa-lightbulb"></i>
        <span>Certifique-se de ter uma conta WhatsApp Business configurada antes de prosseguir.</span>
      </div>

      <!-- Error Banner -->
      <div *ngIf="fbError" class="error-banner">
        <i class="fas fa-exclamation-triangle"></i>
        <div class="error-content">
          <strong>Não foi possível carregar o SDK do Facebook</strong>
          <span>Verifique se bloqueadores de anúncios estão desativados e tente novamente.</span>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="actions-modern">
        <button
          class="btn-connect"
          (click)="launchWhatsAppSignup()"
          [disabled]="loading">
          <i class="fab fa-whatsapp" [class.fa-spin]="loading"></i>
          <span>{{ loading ? 'Conectando...' : 'Conectar WhatsApp' }}</span>
        </button>


        <button
          *ngIf="fbError"
          class="btn-reload"
          (click)="reloadPage()">
          <i class="fas fa-redo"></i>
          <span>Recarregar</span>
        </button>
      </div>

      <!-- Dev Tools Section -->
      <div *ngIf="isDevelopment || mostrarFerramentasTeste" class="dev-tools-modern">
        <div class="dev-tools-header">
          <i class="fas fa-code"></i>
          <h6>Ferramentas de Desenvolvimento</h6>
        </div>
        <p class="dev-tools-desc">
          Gere e aplique rapidamente um token temporário (1 hora) para testar integrações locais.
        </p>
        <p *ngIf="facebookSdkConfig" class="dev-tools-desc">
          App Meta em uso: <strong>{{facebookSdkConfig.appName}}</strong>
          (ID {{facebookSdkConfig.appId}})
        </p>

        <button type="button" class="btn-generate-token" (click)="abrirGeradorToken()">
          <i class="fas fa-external-link-alt"></i>
          Gerar token de 1 hora
        </button>

        <div class="token-input-group">
          <label for="tokenTemporario">Token temporário</label>
          <textarea
            id="tokenTemporario"
            [(ngModel)]="tokenTemporario"
            placeholder="Cole aqui o token de desenvolvimento gerado no Facebook"
            rows="3"></textarea>
        </div>

        <button
          type="button"
          class="btn-save-token"
          (click)="salvarTokenTemporario()"
          [disabled]="loading">
          <i class="fas fa-check" [class.fa-spin]="loading"></i>
          Salvar token
        </button>
      </div>
    </div>
  </ng-container>

  <div *ngIf="dadosIntegracao.associado" class="connected-modern">
    <!-- Status Banner Moderno -->
    <div class="status-banner-modern">
      <div class="status-banner-main">
        <div class="status-banner-content">
          <div class="status-icon-modern">
            <i class="fas fa-check"></i>
            <div class="status-icon-ring"></div>
          </div>
          <div class="status-info">
            <span class="status-kicker">Conexão ativa</span>
            <h3>WhatsApp Business conectado</h3>
            <p>Sua conta já está pronta. O próximo passo é definir como avisar o cliente fora da janela de 24h.</p>
          </div>
        </div>
        <div class="status-summary-strip" *ngIf="telefonePrincipalTemplates as telefonePrincipal">
          <span class="status-summary-item">
            <strong>Número</strong>
            {{ telefonePrincipal.telefone || 'Não informado' }}
          </span>
          <span class="status-summary-item">
            <strong>Status</strong>
            {{ telefonePrincipal.status === 'VERIFIED' ? 'Verificado' : 'Pendente' }}
          </span>
          <span class="status-summary-item">
            <strong>Qualidade</strong>
            {{ telefonePrincipal.rating === 'UNKNOWN' ? 'Indisponível' :
               telefonePrincipal.rating === 'GREEN' ? 'Alta' :
               telefonePrincipal.rating === 'YELLOW' ? 'Média' : 'Baixa' }}
          </span>
        </div>
      </div>
      <div class="status-actions-modern">
        <button
          class="btn-test-modern"
          (click)="testarConexao()"
          [disabled]="loading">
          <i class="fas fa-signal" [class.fa-spin]="testando"></i>
          <span>{{ testando ? 'Testando...' : 'Testar Conexão' }}</span>
        </button>
        <button
          class="btn-disconnect-modern"
          (click)="desconectar()"
          [disabled]="loading">
          <i class="fas fa-power-off" [class.fa-spin]="loading"></i>
          <span>{{ loading ? 'Desconectando...' : 'Desconectar' }}</span>
        </button>
      </div>
    </div>

    <section class="pricing-usage-card" aria-labelledby="pricing-usage-title">
      <div class="pricing-usage-header">
        <div class="pricing-usage-icon" aria-hidden="true">
          <i class="fas fa-chart-bar"></i>
        </div>

        <div class="pricing-usage-copy">
          <span class="pricing-usage-kicker">Uso da API Oficial · 30 dias</span>
          <h4 id="pricing-usage-title">Mensagens entregues por categoria</h4>
          <p>Acompanhe quantas mensagens chegaram aos seus clientes em cada categoria.</p>
        </div>

        <div class="pricing-usage-state" aria-live="polite">
          <div class="pricing-usage-loading" *ngIf="carregandoResumoMensagensPricing">
            <i class="fas fa-circle-notch fa-spin" aria-hidden="true"></i>
            <span>Consultando a Meta...</span>
          </div>

          <div class="pricing-usage-error" *ngIf="!carregandoResumoMensagensPricing && falhaResumoMensagensPricing">
            <span>Não foi possível consultar a Meta agora.</span>
            <button type="button" (click)="carregueResumoMensagensPricing()">Tentar novamente</button>
          </div>

          <div class="pricing-usage-total"
               *ngIf="!carregandoResumoMensagensPricing && !falhaResumoMensagensPricing && resumoMensagensPricing">
            <strong>{{ resumoMensagensPricing.total | number:'1.0-0' }}</strong>
            <span>mensagens entregues</span>
          </div>
        </div>
      </div>

      <ng-container *ngIf="!carregandoResumoMensagensPricing && !falhaResumoMensagensPricing && resumoMensagensPricing">
        <dl class="pricing-category-grid">
          <div class="pricing-category-item" *ngFor="let categoria of resumoMensagensPricing.categorias">
            <dt>{{ categoria.nome }}</dt>
            <dd>{{ categoria.total | number:'1.0-0' }}</dd>
          </div>
        </dl>

        <div class="pricing-usage-footer">
          <span>Volumes entregues informados pela própria Meta.</span>
          <span>Período de {{ resumoMensagensPricing.periodo.inicio }} a {{ resumoMensagensPricing.periodo.fim }}</span>
        </div>
      </ng-container>
    </section>

    <!-- Card de Detalhes Moderno -->
    <div class="details-card-modern" *ngIf="telefones.length > 0">
      <div *ngFor="let telefone of telefones; let i = index" class="phone-card">
        <div class="phone-card-header">
          <div class="phone-card-title">
            <i class="fas fa-mobile-alt"></i>
            <span>Resumo da conexão</span>
          </div>
          <span class="connection-badge">
            <i class="fas fa-calendar-check"></i>
            {{ telefone.dataCriacao ? ('Conectado em ' + (telefone.dataCriacao | date:'dd/MM/yyyy HH:mm')) : 'Data de conexão não disponível' }}
          </span>
        </div>

        <div class="phone-card-body">
          <div class="info-grid">
            <div class="info-item">
              <div class="info-icon info-icon-green">
                <i class="fab fa-whatsapp"></i>
              </div>
              <div class="info-content">
                <span class="info-label">Número</span>
                <span class="info-value info-value-mono">{{ telefone.telefone }}</span>
              </div>
            </div>

            <div class="info-item">
              <div class="info-icon info-icon-blue">
                <i class="fas fa-building"></i>
              </div>
              <div class="info-content">
                <span class="info-label">Nome</span>
                <span class="info-value">{{ telefone.nome }}</span>
              </div>
            </div>

            <div class="info-item">
              <div class="info-icon" [ngClass]="{
                'info-icon-yellow': telefone.status === 'NOT_VERIFIED',
                'info-icon-green': telefone.status === 'VERIFIED'
              }">
                <i class="fas" [ngClass]="{
                  'fa-clock': telefone.status === 'NOT_VERIFIED',
                  'fa-check-circle': telefone.status === 'VERIFIED'
                }"></i>
              </div>
              <div class="info-content">
                <span class="info-label">Status</span>
                <span class="status-pill" [ngClass]="{
                  'status-pill-pending': telefone.status === 'NOT_VERIFIED',
                  'status-pill-verified': telefone.status === 'VERIFIED'
                }">
                  {{ telefone.status === 'NOT_VERIFIED' ? 'Pendente' : 'Verificado' }}
                </span>
              </div>
            </div>

            <div class="info-item">
              <div class="info-icon" [ngClass]="{
                'info-icon-gray': telefone.rating === 'UNKNOWN',
                'info-icon-green': telefone.rating === 'GREEN',
                'info-icon-yellow': telefone.rating === 'YELLOW',
                'info-icon-red': telefone.rating === 'RED'
              }">
                <i class="fas fa-chart-line"></i>
              </div>
              <div class="info-content">
                <span class="info-label">Qualidade</span>
                <span class="quality-pill" [ngClass]="{
                  'quality-pill-unknown': telefone.rating === 'UNKNOWN',
                  'quality-pill-green': telefone.rating === 'GREEN',
                  'quality-pill-yellow': telefone.rating === 'YELLOW',
                  'quality-pill-red': telefone.rating === 'RED'
                }">
                  {{ telefone.rating === 'UNKNOWN' ? 'Indisponível' :
                     telefone.rating === 'GREEN' ? 'Alta' :
                     telefone.rating === 'YELLOW' ? 'Média' : 'Baixa' }}
                </span>
              </div>
            </div>
          </div>

          <button
            type="button"
            class="tech-info-toggle"
            (click)="alternarIdsTecnicos(telefone, i)"
            [attr.aria-expanded]="idsTecnicosEstaAberto(telefone, i)">
            <i
              class="fas fa-angle-right tech-toggle-icon"
              [class.is-open]="idsTecnicosEstaAberto(telefone, i)"></i>
            <span>Ver IDs técnicos</span>
          </button>

          <div class="tech-info" *ngIf="idsTecnicosEstaAberto(telefone, i)">
            <div class="tech-item">
              <span class="tech-label"><i class="fas fa-hashtag"></i> ID WhatsApp</span>
              <span class="tech-value">{{ telefone.whatsapp_id }}</span>
            </div>
            <div class="tech-item">
              <span class="tech-label"><i class="fas fa-hashtag"></i> ID WABA</span>
              <span class="tech-value">{{ telefone.waba_id }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="config-v3-container">
      <div class="workflow-step-card workflow-step-card-toggle">
        <div class="workflow-step-head">
          <div class="workflow-step-icon">
            <i class="far fa-bell"></i>
          </div>
          <div class="workflow-step-copy">
            <span class="workflow-step-label">Passo 1</span>
            <h3>Enviar atualizações automáticas do pedido</h3>
            <p>Quando estiver ligado, o cliente continua recebendo mensagens sobre o pedido, mesmo se a última conversa já passou de 24h.</p>
          </div>
          <div class="workflow-step-action">
            <div class="switch-wrapper">
              <span class="switch-label">Envio automático</span>
              <kendo-switch
                [(ngModel)]="statusTemplates.enviarTemplateForaJanela"
                [onLabel]="''"
                [offLabel]="''"
                [disabled]="carregandoTemplates || atualizandoEnvioTemplateForaJanela"
                (valueChange)="alterarEnvioTemplateForaJanela($event)">
              </kendo-switch>
            </div>
          </div>
        </div>

        <div class="workflow-step-note" [class.is-disabled]="!statusTemplates.enviarTemplateForaJanela">
          <i class="fas" [ngClass]="statusTemplates.enviarTemplateForaJanela ? 'fa-check-circle' : 'fa-exclamation-circle'"></i>
          <span *ngIf="statusTemplates.enviarTemplateForaJanela; else envioDesativadoResumo">
            Ativado. O cliente pode continuar recebendo atualizações automáticas do pedido, com cobrança das mensagens da Meta fora da janela de 24h.
          </span>
          <ng-template #envioDesativadoResumo>
            <span>Desativado. Se a última conversa já passou de 24h, o sistema não envia novas atualizações automáticas.</span>
          </ng-template>
        </div>
      </div>

      <div class="workflow-step-card workflow-step-card-strategy">
        <div class="workflow-step-head workflow-step-head-compact">
          <div class="workflow-step-copy">
            <span class="workflow-step-label">Passo 2</span>
            <h3>Como avisar o cliente?</h3>
            <p>Escolha entre avisos por etapa ou mensagem única com link.</p>
          </div>
        </div>

        <ng-container *ngIf="statusTemplates.enviarTemplateForaJanela; else estadoEstrategiaDesativado">
          <div class="reference-panel notifications-panel">
            <div class="workflow-strategy-meta">
              <span class="workflow-strategy-meta-pill">
                Categoria <strong class="category-utility">Utilidade</strong>
              </span>
              <span class="workflow-strategy-meta-pill">
                R$ {{ custoMensagemUtilidadeBrl | number:'1.2-2' }} por mensagem
              </span>
            </div>

            <div class="reference-strategy-grid">
              <div
                class="reference-strategy-card"
                [class.is-selected]="modoNotificacaoPedido === 'por_status'"
                (click)="alterarModoNotificacaoPedido('por_status')">
                <div class="reference-card-top">
                  <div class="reference-radio" [class.checked]="modoNotificacaoPedido === 'por_status'"></div>
                  <div class="reference-card-title-wrap">
                    <div class="reference-card-title-row">
                      <h5>Notificações por etapa</h5>
                      <span class="reference-badge">RECOMENDADA</span>
                    </div>
                    <p>Uma mensagem a cada mudança de status. Mais engajamento.</p>
                  </div>
                </div>

                <div class="reference-timeline-chips">
                  <span>Pedido</span>
                  <i class="fas fa-angle-right"></i>
                  <span>Preparo</span>
                  <i class="fas fa-angle-right"></i>
                  <span>Pronto</span>
                  <i class="fas fa-angle-right"></i>
                  <span>Saiu</span>
                  <i class="fas fa-angle-right"></i>
                  <span>Entregue</span>
                </div>

                <div class="reference-card-footer">
                  <span>5 mensagens por pedido</span>
                </div>
              </div>

              <div
                class="reference-strategy-card compact"
                [class.is-selected]="modoNotificacaoPedido === 'unica'"
                (click)="alterarModoNotificacaoPedido('unica')">
                <div class="reference-card-top">
                  <div class="reference-radio" [class.checked]="modoNotificacaoPedido === 'unica'"></div>
                  <div class="reference-card-title-wrap">
                    <div class="reference-card-title-row">
                      <h5>Mensagem única com link</h5>
                    </div>
                    <p>Uma mensagem e o cliente acompanha por link externo.</p>
                  </div>
                </div>

                <div class="reference-link-box">
                  Cliente acompanha pelo link
                </div>

                <div class="reference-card-footer compact-footer">
                  <span>1 mensagem por pedido</span>
                  <strong>economiza 80%</strong>
                </div>
              </div>
            </div>

            <div class="reference-cost-strip">
              <span class="cost-strip-label">Custo estimado · {{ calculadoraPedidosPorMes }} pedidos/mês</span>
              <div class="cost-strip-actions">
                <div class="cost-strip-price">
                  <strong>R$ {{ custoEstimadoNotificacaoPedidoBrl | number:'1.2-2' }}</strong>
                  <span>/ mês</span>
                </div>
                <button type="button" class="btn-adjust-volume" (click)="abrirCalculadora()">
                  Ajustar volume
                </button>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-template #estadoEstrategiaDesativado>
          <div class="workflow-disabled-panel">
            <i class="fas fa-lock"></i>
            <div>
              <strong>Ative o passo 1 para escolher a estratégia.</strong>
              <span>Depois você decide entre avisos por etapa ou mensagem única com link.</span>
            </div>
          </div>
        </ng-template>
      </div>

      <div class="workflow-optional-block" *ngIf="statusTemplates.enviarTemplateForaJanela">
        <div class="workflow-optional-head">
          <span class="workflow-optional-kicker">Opcional</span>
          <h3>Notificações marcadas como marketing</h3>
          <p>Algumas notificações podem ser classificadas pela Meta nessa categoria, com outro custo e controle de envio.</p>
        </div>

        <div class="workflow-step-card workflow-step-card-marketing">
          <div
            class="reference-panel marketing-reference-panel"
            [class.is-disabled]="!statusTemplates.enviarTemplateMarketing">
            <div class="reference-section-head">
              <div class="reference-section-copy">
                <h4>Controle de envio</h4>
                <p>
                  <span class="category-marketing">Marketing</span>
                  · R$ {{ custoMensagemMarketingBrl | number:'1.2-2' }} por mensagem
                </p>
                <p class="reference-section-helper">
                  Este controle vale apenas para templates que a Meta classificou como marketing. As notificações utilitárias do pedido continuam normais.
                </p>
              </div>
              <div class="reference-switch-area">
                <div class="reference-switch-copy">
                  <strong>Enviar notificações classificadas como marketing?</strong>
                  <small>
                    {{
                      statusTemplates.enviarTemplateMarketing
                        ? 'Ligado: esses templates podem ser enviados se estiverem aprovados.'
                        : 'Desligado: esses templates não serão enviados.'
                    }}
                  </small>
                </div>
                <kendo-switch
                  [(ngModel)]="statusTemplates.enviarTemplateMarketing"
                  [onLabel]="''"
                  [offLabel]="''"
                  (valueChange)="alterarEnvioTemplateMarketing($event)">
                </kendo-switch>
              </div>
            </div>

            <div class="reference-warning-strip">
              <i class="far fa-exclamation-triangle"></i>
              <span>Marketing custa cerca de 10x mais que utilidade.</span>
            </div>

            <div class="reference-marketing-summary">
              <span class="reference-marketing-summary-item">
                <strong>{{ templatesMarketing.length }}</strong>
                templates classificados como marketing
              </span>
              <span class="reference-marketing-summary-item" *ngIf="quantidadeTemplatesMarketingAguardando > 0">
                <strong>{{ quantidadeTemplatesMarketingAguardando }}</strong>
                aguardando aprovação
              </span>
            </div>

            <div class="reference-section-label" *ngIf="templatesMarketing && templatesMarketing.length > 0">
              TEMPLATES CLASSIFICADOS COMO MARKETING PELA META
            </div>

            <div class="reference-marketing-chips" *ngIf="templatesMarketing && templatesMarketing.length > 0">
              <div
                class="reference-marketing-chip"
                [class.approved]="template.status === 'APPROVED'"
                *ngFor="let template of templatesMarketing">
                <span class="chip-check">
                  <i class="fas" [ngClass]="template.status === 'APPROVED' ? 'fa-check-square' : 'fa-square'"></i>
                </span>
                <span>{{ obtenhaDescricaoTipoNotificacao(template.tipoNotificacao) }}</span>
              </div>
            </div>

            <div class="reference-marketing-empty" *ngIf="templatesMarketing && templatesMarketing.length === 0">
              Nenhum template foi classificado como marketing pela Meta até agora.
            </div>

            <div class="reference-marketing-empty" *ngIf="!statusTemplates.enviarTemplateMarketing && templatesMarketing && templatesMarketing.length > 0">
              O envio está pausado, mas estes templates continuam nessa categoria.
            </div>

            <div class="reference-meta-table">
              <div class="meta-table-label">TABELA META VIGENTE</div>
              <div class="meta-table-values">
                <span>Marketing <strong>R$ {{ custoMensagemMarketingBrl | number:'1.2-2' }}</strong> <small>/ msg</small></span>
                <span>Utilidade <strong>R$ {{ custoMensagemUtilidadeBrl | number:'1.2-2' }}</strong> <small>/ msg</small></span>
                <span>Janela 24h <strong class="gratis">Grátis</strong></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

      <!-- Modal da Calculadora -->
      <div class="calculator-modal-overlay" *ngIf="mostrarCalculadora" (click)="fecharCalculadora()">
        <div class="calculator-modal-content" (click)="$event.stopPropagation()">
          <div class="modal-header-custom">
            <h3>
              <i class="fas fa-calculator"></i>
              Simulador de Custos Meta
            </h3>
            <button class="btn-close-modal" (click)="fecharCalculadora()">
              <i class="fas fa-times"></i>
            </button>
          </div>

          <div class="modal-body-custom">
            <div class="calculadora-waba">
              <!-- Header com cotação -->
              <div class="calc-waba-header">
                <div class="calc-waba-title">
                  <i class="fab fa-facebook"></i>
                  <span>ESTIMATIVA DE CUSTOS META</span>
                </div>
                <div class="calc-cotacao-badge">
                  <span>USD 1.00 = R$ {{ cotacaoUsdBrl.toFixed(2).replace('.', ',') }}</span>
                </div>
              </div>

              <!-- Layout principal duas colunas -->
              <div class="calc-waba-layout">
                <!-- Coluna Esquerda: Configurações -->
                <div class="calc-waba-main">

                  <!-- SEÇÃO 1: Categoria do Template -->
                  <div class="calc-waba-section">
                    <div class="calc-section-number">1</div>
                    <h3 class="calc-section-title">CATEGORIA DO TEMPLATE</h3>

                    <!-- Layout Novo: Seletores Compactos + Painel de Detalhes -->
                    <div class="calc-categoria-compact-layout">
                      <!-- 1. Seletores (Abas) -->
                      <div class="calc-cat-buttons">
                        <!-- Botão Marketing -->
                        <button class="calc-cat-btn"
                                [class.active]="calculadoraCategoria === 'marketing'"
                                (click)="calculadoraCategoria = 'marketing'">
                          <div class="cat-btn-icon marketing">
                            <i class="fas fa-bullhorn"></i>
                          </div>
                          <div class="cat-btn-info">
                            <span class="cat-name">Marketing</span>
                            <span class="cat-price">US$ 0.0625</span>
                          </div>
                          <div class="cat-check" *ngIf="calculadoraCategoria === 'marketing'">
                            <i class="fas fa-check-circle"></i>
                          </div>
                        </button>

                        <!-- Botão Utilidade -->
                        <button class="calc-cat-btn"
                                [class.active]="calculadoraCategoria === 'utility'"
                                (click)="calculadoraCategoria = 'utility'">
                          <div class="cat-btn-icon utilidade">
                            <i class="fas fa-cog"></i>
                          </div>
                          <div class="cat-btn-info">
                            <span class="cat-name">Utilidade</span>
                            <span class="cat-price">US$ 0.0068</span>
                          </div>
                          <div class="cat-check" *ngIf="calculadoraCategoria === 'utility'">
                            <i class="fas fa-check-circle"></i>
                          </div>
                        </button>

                        <!-- Botão Serviço -->
                        <button class="calc-cat-btn"
                                [class.active]="calculadoraCategoria === 'service'"
                                (click)="calculadoraCategoria = 'service'">
                          <div class="cat-btn-icon servico">
                            <i class="fas fa-headset"></i>
                          </div>
                          <div class="cat-btn-info">
                            <span class="cat-name">Janela 24h</span>
                            <span class="cat-price gratis">Grátis*</span>
                          </div>
                          <div class="cat-check" *ngIf="calculadoraCategoria === 'service'">
                            <i class="fas fa-check-circle"></i>
                          </div>
                        </button>
                      </div>

                      <!-- 2. Painel de Detalhes Dinâmico -->
                      <div class="calc-cat-details-panel" [ngSwitch]="calculadoraCategoria">

                        <!-- Detalhes Marketing -->
                        <div *ngSwitchCase="'marketing'" class="cat-detail-content marketing">
                          <div class="detail-header">
                            <span class="detail-badge high-cost">Sempre cobradas</span>
                            <p>Ideal para promoções, ofertas e novidades.</p>
                          </div>
                        </div>

                        <!-- Detalhes Utilidade -->
                        <div *ngSwitchCase="'utility'" class="cat-detail-content utilidade">
                          <div class="detail-header">
                            <span class="detail-badge recommended">Recomendado</span>
                            <span class="detail-badge neutral">Cliente não mandou mensagem</span>
                            <p>Atualizações de pedido (status), confirmações e recibos.</p>
                          </div>
                        </div>

                        <!-- Detalhes Serviço -->
                        <div *ngSwitchCase="'service'" class="cat-detail-content servico">
                          <div class="detail-header">
                            <span class="detail-badge success">Cliente Mandou Mensagem</span>
                            <p>Responda grátis por 24h após o cliente falar. Inclui status, dúvidas e qualquer mensagem.</p>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>

                  <!-- SEÇÃO 2: Volume Mensal -->
                  <div class="calc-waba-section">
                    <div class="calc-section-number">2</div>
                    <h3 class="calc-section-title">VOLUME MENSAL</h3>

                    <div class="calc-volume-container">
                      <div class="calc-volume-header">
                        <span class="calc-volume-label">
                          {{ calculadoraCategoria === 'marketing' ? 'MENSAGENS NA CAMPANHA' : 'PEDIDOS PROCESSADOS' }}
                        </span>
                        <div class="calc-volume-display">
                          <input type="number"
                                 *ngIf="calculadoraCategoria === 'marketing'"
                                 class="calc-volume-input"
                                 [(ngModel)]="calculadoraQtdMensagens"
                                 [min]="100"
                                 [max]="10000">
                          <input type="number"
                                 *ngIf="calculadoraCategoria !== 'marketing'"
                                 class="calc-volume-input"
                                 [(ngModel)]="calculadoraPedidosPorMes"
                                 [min]="10"
                                 [max]="10000">
                          <span class="calc-volume-unit">{{ calculadoraCategoria === 'marketing' ? 'mensagens' : 'pedidos/mês' }}</span>
                        </div>
                      </div>

                      <div class="calc-slider-container">
                        <!-- Slider para Marketing -->
                        <input type="range"
                               *ngIf="calculadoraCategoria === 'marketing'"
                               class="calc-slider"
                               [min]="100"
                               [max]="10000"
                               [step]="100"
                               [(ngModel)]="calculadoraQtdMensagens">
                        <!-- Slider para Utilidade/Serviço -->
                        <input type="range"
                               *ngIf="calculadoraCategoria !== 'marketing'"
                               class="calc-slider"
                               [min]="10"
                               [max]="10000"
                               [step]="10"
                               [(ngModel)]="calculadoraPedidosPorMes">
                        <div class="calc-slider-labels">
                          <span>{{ calculadoraCategoria === 'marketing' ? '100' : '10' }} {{ calculadoraCategoria === 'marketing' ? 'MSGS' : 'PEDIDOS' }}</span>
                          <span>5.000 {{ calculadoraCategoria === 'marketing' ? 'MSGS' : 'PEDIDOS' }}</span>
                          <span>10.000+ {{ calculadoraCategoria === 'marketing' ? 'MSGS' : 'PEDIDOS' }}</span>
                        </div>
                      </div>

                      <!-- Seletor de Moeda -->
                      <div class="calc-moeda-selector">
                        <label>Moeda de exibição:</label>
                        <select [(ngModel)]="calculadoraMoeda">
                          <option value="BRL">Real (BRL)</option>
                          <option value="USD">Dólar (USD)</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <!-- SEÇÃO 3: Estratégia de Envio -->
                  <div class="calc-waba-section">
                    <div class="calc-section-number">3</div>
                    <h3 class="calc-section-title">ESTRATÉGIA DE ENVIO</h3>

                    <div class="calc-estrategia-cards">
                      <!-- Card Transacional (Padrão) -->
                      <label class="calc-estrategia-card"
                             [class.active]="modoNotificacaoPedido === 'por_status'">
                        <div class="calc-estrategia-radio">
                          <div class="radio-circle"></div>
                        </div>
                        <input type="radio"
                               name="estrategia_calc"
                               value="por_status"
                               style="display: none;"
                               [(ngModel)]="modoNotificacaoPedido"
                               (change)="alterarModoNotificacaoPedido('por_status')">
                        <div class="calc-estrategia-header">
                          <div class="calc-estrategia-icon">
                            <i class="fas fa-layer-group"></i>
                          </div>
                          <div class="calc-estrategia-title">
                            <span class="nome">Notificações por Etapa</span>
                            <span class="subtitulo">(Opção 1) Envia uma mensagem a cada mudança de status.</span>
                          </div>
                        </div>
                        <p class="calc-estrategia-destaque">Média de <strong>5 mensagens</strong> por pedido.</p>

                        <!-- Timeline visual -->
                        <div class="calc-fluxo-timeline">
                          <div class="timeline-item">
                            <i class="fas fa-clipboard-list"></i>
                            <span>Pedido</span>
                          </div>
                          <div class="timeline-arrow"><i class="fas fa-chevron-right"></i></div>
                          <div class="timeline-item">
                            <i class="fas fa-fire"></i>
                            <span>Preparando</span>
                          </div>
                          <div class="timeline-arrow"><i class="fas fa-chevron-right"></i></div>
                          <div class="timeline-item">
                            <i class="fas fa-check-circle"></i>
                            <span>Pronto</span>
                          </div>
                          <div class="timeline-arrow"><i class="fas fa-chevron-right"></i></div>
                          <div class="timeline-item">
                            <i class="fas fa-motorcycle"></i>
                            <span>Saiu</span>
                          </div>
                          <div class="timeline-arrow"><i class="fas fa-chevron-right"></i></div>
                          <div class="timeline-item">
                            <i class="fas fa-box-open"></i>
                            <span>Entregue</span>
                          </div>
                        </div>

                        <div class="calc-estrategia-custo padrao">
                          <span>Serão cobradas <strong>5 mensagens</strong> por pedido.</span>
                        </div>
                      </label>

                      <!-- Card Fluxo Inteligente -->
                      <label class="calc-estrategia-card inteligente"
                             [class.active]="modoNotificacaoPedido === 'unica'">
                        <div class="calc-estrategia-radio">
                          <div class="radio-circle"></div>
                        </div>
                        <div class="calc-estrategia-badge-destaque">
                          <i class="fas fa-chart-line"></i> 80% DE ECONOMIA
                        </div>
                        <input type="radio"
                               name="estrategia_calc"
                               value="unica"
                               style="display: none;"
                               [(ngModel)]="modoNotificacaoPedido"
                               (change)="alterarModoNotificacaoPedido('unica')">
                        <div class="calc-estrategia-header">
                          <div class="calc-estrategia-icon inteligente">
                            <i class="fas fa-link"></i>
                          </div>
                          <div class="calc-estrategia-title">
                            <span class="nome">Mensagem Única Por Pedido</span>
                            <span class="subtitulo inteligente">(Opção 2) Envia 1 mensagem com link e atualiza tudo por lá.</span>
                          </div>
                        </div>

                        <div class="calc-estrategia-api-badge">
                          <i class="fas fa-external-link-alt"></i>
                          <span>Cliente acompanha pelo link</span>
                        </div>

                        <div class="calc-estrategia-economia">
                          <i class="fas fa-bolt"></i>
                          <span>Alta Performance</span>
                        </div>

                        <div class="calc-estrategia-custo economia">
                          <span>Total: 1 Mensagem de Utilidade</span>
                        </div>
                      </label>
                    </div>
                  </div>

                  <!-- Link para tabela de preços -->
                  <div class="calc-footer-link">
                    <a href="javascript:void(0)" (click)="abrirTabelaPrecosMeta()">
                      <i class="fas fa-external-link-alt"></i>
                      Ver tabela completa de preços da Meta
                    </a>
                  </div>
                </div>

                <!-- Coluna Direita: Card de Resumo -->
                <div class="calc-waba-sidebar" id="detalhesCalculadora">
                  <div class="calc-resumo-card-v2">
                    <!-- Header com valor principal -->
                    <div class="calc-resumo-header-v2">
                      <span class="calc-resumo-label">PREVISÃO DE CUSTO MENSAL</span>
                      <span class="calc-resumo-sublabel"><i class="fab fa-facebook"></i> Pagos diretamente à Meta</span>
                      <div class="calc-resumo-valor-principal">
                        <span class="valor" [class.gratis]="calculadoraCategoria === 'service'">
                          {{ calculadoraCategoria === 'service' ? 'Grátis' : simboloMoeda + ' ' + formatarValorSemSimbolo(custoTotalMensal) }}
                        </span>
                        <span class="moeda" *ngIf="calculadoraCategoria !== 'service'">{{ calculadoraMoeda }}</span>
                      </div>
                      <span class="calc-resumo-comparativo" *ngIf="modoNotificacaoPedido === 'unica' && calculadoraCategoria === 'utility'">
                        ao invés de <span class="valor-riscado">{{ simboloMoeda }} {{ formatarValorSemSimbolo(custoTotalMensal + economiaGerada) }}</span> (notificação por etapa).
                      </span>
                      <span class="calc-resumo-equivalente" *ngIf="calculadoraMoeda === 'BRL' && calculadoraCategoria !== 'service'">
                        ≈ US$ {{ formatarValorSemSimbolo(custoEquivalenteUSD, 2) }}
                      </span>
                      <div class="calc-resumo-icon-check">
                        <i class="fas fa-check-circle"></i>
                      </div>
                    </div>

                    <!-- Composição do Custo -->
                    <div class="calc-resumo-composicao">
                      <h4>COMPOSIÇÃO DO CUSTO</h4>
                      <div class="composicao-item">
                        <span>Volume de {{ calculadoraCategoria === 'marketing' ? 'Mensagens' : 'Pedidos' }}</span>
                        <span class="valor">{{ calculadoraCategoria === 'marketing' ? calculadoraQtdMensagens : calculadoraPedidosPorMes }}</span>
                      </div>
                      <div class="composicao-item destaque" *ngIf="calculadoraCategoria !== 'marketing'">
                        <span>× Mensagens por Pedido ({{ modoNotificacaoPedido === 'unica' ? 'Otimizado' : 'Padrão' }})</span>
                        <span class="valor">{{ sessoesPorPedido }}x</span>
                      </div>
                      <div class="composicao-item resultado" *ngIf="calculadoraCategoria !== 'marketing'">
                        <span>= Total de Mensagens</span>
                        <span class="valor">{{ totalSessoesPagas }}</span>
                      </div>
                      <div class="composicao-item">
                        <span>× Tarifa ({{ nomeCategoriaSelecionada }})</span>
                        <span class="valor">$ {{ tarifaSelecionadaUSD.toFixed(4) }}</span>
                      </div>
                    </div>

                    <!-- Entenda a Regra de 24h -->
                    <div class="calc-resumo-regra24h">
                      <div class="regra-header">
                        <i class="fas fa-question-circle"></i>
                        <span>ENTENDA A REGRA DE 24H</span>
                      </div>
                      <p class="regra-texto">O WhatsApp cobra por <strong>"janelas de 24 horas"</strong>.</p>
                      <p class="regra-exemplo">Após 24 horas, as mensagens só podem ser enviadas utilizando <strong>templates</strong> e são cobradas pela Meta de acordo com a categoria da mensagem (classificada automaticamente pela Meta).</p>
                      <p class="regra-nota">*Valores baseados na tabela Meta vigente (Dez/2024). Impostos locais não inclusos.</p>
                    </div>

                    <!-- Badges de confiança -->
                    <div class="calc-resumo-badges">
                      <div class="badge-item">
                        <i class="fab fa-whatsapp"></i>
                        <span>WHATSAPP VERIFIED</span>
                      </div>
                      <div class="badge-item">
                        <i class="fas fa-globe-americas"></i>
                        <span>GLOBAL DELIVERY</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Sticky Footer Mobile -->
          <div class="calc-mobile-sticky-footer" (click)="rolarParaDetalhes()">
            <div class="sticky-handle">
              <i class="fas fa-chevron-up"></i>
            </div>
            <div class="sticky-footer-content">
              <div class="sticky-left">
                <span class="sticky-label">Custo Mensal</span>
                <div class="sticky-details">
                   <span>{{ calculadoraCategoria === 'marketing' ? calculadoraQtdMensagens : calculadoraPedidosPorMes }} {{ calculadoraCategoria === 'marketing' ? 'msgs' : 'pedidos' }}</span>
                   <span *ngIf="calculadoraCategoria === 'utility'"> • {{ modoNotificacaoPedido === 'unica' ? '1 msg/ped' : '5 msgs/ped' }}</span>
                </div>
              </div>
              <div class="sticky-right">
                <span class="sticky-value" [class.gratis]="calculadoraCategoria === 'service'">
                  {{ calculadoraCategoria === 'service' ? 'Grátis' : simboloMoeda + ' ' + formatarValorSemSimbolo(custoTotalMensal) }}
                </span>
                <span class="sticky-approx" *ngIf="calculadoraMoeda === 'BRL' && calculadoraCategoria !== 'service'">
                  ≈ US$ {{ formatarValorSemSimbolo(custoEquivalenteUSD, 2) }}
                </span>
              </div>
            </div>
          </div>

        </div>
      </div>

    <!-- Seção de Estatísticas -->

</div>
